export default __webpack_public_path__ + "static/media/main_saying03_cn.0bca3ba5.png";